export class ContactViewModel {
  constructor(u) {
    this.telephone = u.telephone;
    this.phone = u.phone;
    this.full_name = u.full_name;
    this.email = u.email;
  }
}
